import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd, ActivatedRoute } from '@angular/router';
import { HeaderComponent } from "./shared/components/header/header.component";
import { FooterComponent } from "./shared/components/footer/footer.component";
import { LandingComponent } from "./features/landing/landing.component";
import { PortalUtilityBarComponent } from '@shared/components/portal-utility-bar/portal-utility-bar.component';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { environment } from '@environments/environment';
import { UserStore } from '@shared/stores/user/user.store';
import { isEmptyObject } from '@shared/utilities/common.utils';
import { Subscription } from 'rxjs';
import { ROUTE_PARAMS } from '@shared/constants/route-params.constants';

@Component({
  selector: 'avenir-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    LoaderComponent,
    ToastComponent,
    PortalUtilityBarComponent,
    FooterComponent,
    LandingComponent,
    CommonModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {
  displayComponent = true;
  clientId = environment.CLIENT_ID;
  sideMenuState = false;
  isLoggedIn: boolean = false;
  routerSubscription!: Subscription;
  customerId: string = '';
  isCustomerChecked: boolean = true;

  constructor(
    private router: Router,
    private userStore: UserStore,
    private activatedRoute: ActivatedRoute
  ) {
    // this.onChangeRoute(router);
  }

 ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scroll(0, 0);

        const url = this.router.url;
        const isSurvey = url.startsWith('/survey/');
        const isUnsubscribe = url.includes('/unsubscribe');
        const isDashboardSection = this.customerId && url.startsWith(`/${this.customerId}/`);

        // Only extract customerId if not on survey routes
        if (!isSurvey) {
          this.isCustomerChecked = true;          
        }
        
        const customerId = this.activatedRoute.firstChild?.snapshot.params[ROUTE_PARAMS.CUSTOMER_ID];
        if (customerId) {
            this.customerId = customerId;
          }

        // Only redirect if not on survey/unsubscribe/dashboard
        if (!isEmptyObject(this.userStore.getUser())) {
          this.isLoggedIn = true;
        //   if (this.isLoggedIn && !isSurvey && !isUnsubscribe && !isDashboardSection && this.customerId) {
        //     this.router.navigate([`/${this.customerId}/dashboard`]);
        //   }
        }
      }
    });
  }

  sideMenuStateFnc(sideMenu: boolean) {
    this.sideMenuState = sideMenu;
  }

  // onChangeRoute(router: Router): void {
  //   router.events.subscribe({
  //     next: (event) => {
  //       if (event instanceof NavigationEnd) {
  //         // Scroll to top on every route change
  //         window.scroll(0, 0);
  //       }
  //     }
  //   });
  // }
}